export const English = {
  ok: "Ok",
  loginText: "LOGIN",
  loginCopyright: "© 2022-2023 Sanerret",
  forgotPassword: "Forgot Password?",
  startEF: "Start - EuroFinance",
  startApp: "Start - Appresta",
  paymentOfFees: "Payment of fees",
  back: "Back",
  cancel: "Cancel",
  save: "Save",
  saveAsDraft: "Save as Draft",
  saveDraft: "Save draft",
  continue: "Continue",
  submit: "Submit",
  basicInformation: "Basic Information",
  loanInformation: "Loan Information",
  frontImage: "Front Image",
  backImage: "Back Image",
  profile: "Profile",
  changePassword: "Change Password",
  passwordChanged: "Password Changed",
  yourPasswordHasBeen: "Your password has been",
  changedSuccessfully: "changed successfully",
  logout: "Logout",
  loginAgain: "Login Again",
  admin: "Admin",
  "general manager": "General Manager",
  cashier: "Cashier",
  analyst: "Analyst",
  configurator: "Configurator",
  deactivate: "Deactivate",
  edit: "Edit",
  delete: "Delete",
  relationship: "Relationship",
  transactionListHistory: "Transaction History",
  graphOfTransactions: "Transaction Graph",
  enterBehaviourCurveValue: "Enter Behaviour Curve Value",
  creditScoreUpdatedSuccessfully: "Credit Score Updated Successfully",
  update: "Update",
  userManagement: "User ManageMent",
  addUser: "Add User",
  image: "Image",
  user: "User",
  firstName: "First Name",
  lastName: "Surname",
  role: "Role",
  userDetails: "User Details",
  profileDetails: "Profile Details",
  deactivateUser: "Deactivate user",
  algoVerList: "Algorithm version list",
  emiVerList: "Fee Payment version list",
  versionName: "Version Name",
  status: "Status",
  fullName: "Full Name",
  name: "Name",
  country: "Country of origin",
  telephoneNumber: "TelephoneNumber",
  phoneNumber: "Phone Number",
  homePhoneNumber: "Home",
  email: "Email",
  dateOfBirth: "Date of Birth",
  address: "Address",
  howLongHaveYouLivedAtThatAddress: "How long have you lived at that address",
  years: "Years",
  months: "Months",
  amountRequested: "Amount Requested",
  termRequested: "Term Requested",
  howDoYouPlanToUseYourLoan: "How do you plan to use your loan?",
  anotherReason: "Another Reason",
  repaymentAmount: "Repayment Amount",
  additionalInformation: "Additional Information",
  howLongHaveYouLivedInSpain: "How long have you lived in Spain?",
  howLongHaveYouLivedAtCurrentAddress:
    "How long have you lived at your current address?",
  haveYouHadAFormalOrInformalLoanInThePast6Months:
    "Have you had a formal or informal loan in the past 6 months?",
  yes: "Yes",
  no: "No",
  company: "Company",
  lateRepayments: "Late repayments",
  frequencyOfRemittanceSending: "Frequency of remittance sending",
  perMonth: "per month",
  averageAmount: "Average Amount",
  relationshipToRemittanceReceiver: "Relationship to remittance receiver",
  give2PersonalReferences: "Give 2 personal references",
  reference1: "Reference 1",
  reference2: "Reference 2",
  doYouRentOrLiveInAnOwnedHome: "Do you rent or live in an owned home?",
  select: "Select",
  selectVariable: "Select Variable",
  typeOfHousing: "Type of housing",
  howManyPeopleAreYouFinanciallyResponsibleOf:
    "How many people are you financially responsible of?",
  toDate: "To Date:",
  fromDate: "From Date:",
  enterUserId: "Please enter holco Id.",
  holdoId: "Holdo Id",
  income: "Income",
  companyName: "Company Name",
  amountOfSalary: "What is your monthly salary",
  howLongHaveYouWorkedThere: "How long have you worked there?",
  doYouHaveOtherIncome: "Do you have other income?",
  doYouHaveAnotherSourceOfIncome: " Do you have another source of income?",
  source: "Source",
  howDoYouGetPaid: "How do you get paid?",
  directDeposit: "Direct Deposit",
  cash: "Cash",
  doYouDepositItOrCashOut: "Do you deposit it or cash out?",
  deposit: "Deposit",
  cashOut: " Cash out",
  notApplicable: "N/A",
  whatIsYourTotalAverageIncome: "What is you total average income?",
  doYouHaveABankAccount: "Do you have a bank account?",
  nameOfTheBank: "Name of the Bank",
  workingPartner: " In case you live with a partner, does this person work?",
  whatIsTheirMonthlySalary: "What is their monthly salary?",
  whatIsYourEmploymentSituation: "What is your employment situation?",
  monthlySalary: "Monthly Salary",
  totalIncome: "Total Income",
  monthlyExpenses: "Monthly Expenses",
  housingExpenses: "Housing Expenses",
  carTransportation: "Car/Transportation",
  phone: "Phone",
  amenities: "Amenities (water, electricity, gas, etc)",
  food: "Food",
  medicalBills: "Medical Bills",
  otherExpenses: "Other Expenses",
  remittance: "Remittance",
  loanRepaymentOrCreditCardExpenses: "Loan repayment or credit card expenses",
  totalExpenses: "Total Expenses",
  basicDataAndLoanInformation: "Basic data & Loan Information",
  incomeExpensesMonthly: "Income Expenses Monthly",
  uploadDocument: "Upload Document",
  loanApplication: "Loan Application",
  date: "Date",
  solicitudes: "solicitudes",
  addRequest: "Add Request",
  myRequests: "My Requests",
  requests: "Requests",
  myCommissions: "My Commissions",
  previousCommissions: "Previous commissions",
  statusReport: "Status Report",
  branchReport: "Branch Report",
  you: "You",
  in: "In",
  analystApproval: "Analyst Approval",
  loanDisbursement: "Loan Disbursement",
  toAssign: "To Assign",
  assigned: "Assigned",
  confirm: "Confirm",
  reference: "Reference",
  document: "Document",
  negotiation: "Negotiation",
  customerValidation: "Customer Validation",
  customerValidData: "Customer Valid Data",
  clientAuthorizedKontomatik: "Client authorized access to Kontomatik",
  kontomatikCustomerInformation: "Kontomatik customer information was received",
  refresh: "Refresh",
  disbursement: "Disbursement",
  signatureOfTheContract: "Signature of the Contract",
  disbursedAmount: "Disbursed Amount",
  submitReceipt: "Submit Receipt",
  term: "Term",
  disbursementButtonText: "Disbursed",
  uploadDocuments: "Upload Documents",
  viewDocument: "View",
  upload: "Upload",
  browse: "Browse",
  photoId: "Photo ID",
  proofOfIncome: "Proof of Income",
  proofOfAddress: "Proof of Address",
  spanishId: "Spanish ID (DNI / NIE)",
  drivingLicense: "Driving License",
  recentBankStatements: "Two Most Recent Bank Statements",
  recentPayStubs: "Two Most Recent Pay Stubs",
  transactionHistory:
    "Last Two Months Transaction History (Check Cashing, Bank Transaction)",
  bills: "Electric, Water, Cable, Interner or Phone Bill",
  bankStatement: "Bank Statement",
  currentLease: "Current Lease",
  mailedCreditCardOrLoanOffer: "Mailed Credit Card or Loan Offer",
  photo: "Photo",
  remove: "Remove",
  downloadReceipt: "Download receipt",
  creditAnalysis: "Credit Analysis",
  creditScore: "Credit Score",
  financialSummary: "Financial Summary",
  quantityAvailable: "Quantity Available",
  expenses: "Expenses",
  attachments: "Attachments",
  backgroundCheck: "Background Check",
  addressValidationDocuments:
    "Validation of addresses between documents (ID, EH CRM)",
  addressValidationReference: "Reference validation",

  notes: "Notes",
  addNote: "Add Note",
  referenceCalls: "Reference Calls",
  reference1Validation: "Reference 1 validation",
  reference2Validation: "Reference 2 validation",
  negotiationWithClient: "Negotiation with the Client",
  amountApproved: "Amount Approved",
  approvedTerm: "Approved Term",
  requestedTerm: "Requested Term",
  created: "Created",
  approved: "Approved",
  inProcess: "In Process",
  pending: "Pending",
  submitted: "Submitted",
  rejected: "Rejected",
  incomplete: "Incomplete",
  disbursed: "Disbursed",
  dismissed: "Dismissed",
  clickToViewDetails: "Click to view details",
  january: "Jan",
  february: "Feb",
  march: "Mar",
  april: "Apr",
  may: "May",
  june: "Jun",
  july: "July",
  august: "Aug",
  september: "Sep",
  october: "Oct",
  november: "Nov",
  december: "Dec",
  commissionsLeaderboard: "Commissions Leaderboard",
  commissionByBranch: "Commissions By Branch",
  noRecordsFound: "No records found",
  searchForRecord: "Please use search to get loan application.",
  noData: "No Data",
  noDataAvailable: "No data available",
  doYouWantToDeactivateUser: "Do you want to deactivate user ?",
  doYouWantToAssignApplicationToYourself:
    "Do you want to assign application to yourself ?",
  deleteNoteConfirmation: "Do you want to delete this note ?",
  unsavedDataWillBeLost:
    "The unsaved data will be lost. Do you want to proceed ?",
  submitButtonConfirmationText:
    "Are you sure you want to submit this loan application ?",
  approveButtonConfirmationText:
    "Are you sure you want to approve this loan application ?",
  rejectButtonConfirmationText:
    "Are you sure you want to reject this loan application ?",
  disbursedButtonConfirmationText:
    "Are you sure you want to mark the status of this loan application as Disbursed ?",
  incompleteButtonConfirmationText:
    "Are you sure you want to mark the status of this loan application as Incomplete ?",
  deactivateBranch: "Deactivate Branch",
  doYouWantToDeactivateBranch: "Do you want to Deactivate Branch?",
  success: "Success",
  loanApplicationCreatedSuccessfully: "Loan application created successfully.",
  loanApplicationUpdatedSuccessfully: "Loan application updated successfully.",
  documentUploadedSuccessfully: "Document uploaded successfully.",
  loanApplicationSubmitted: "Loan application is submitted.",
  loanApplicationApproved: "Loan application is approved.",
  loanApplicationRejected: "Loan application is rejected.",
  loanApplicationIncomplete: "Loan application is incomplete.",
  loanDisbursedSuccessfully: "Loan is disbursed.",
  emailHasBeenSent: "E-mail has been sent.",
  userCreatedSuccessfully: "User has been successfully created.",
  userUpdatedSuccessfully: "User has been successfully updated.",
  noteAddedSuccessfuly: "Note added successfully.",
  noteUpdatedSuccessfuly: "Note updated successfully.",
  noteDeletedSuccessfuly: "Note deleted successfully.",
  documentRemovedSuccessfully: "Document removed successfully.",
  addSubtype: "Add subtype",
  createdBy: "Created by",
  version: "Edit version",
  versionText: "Version",
  getActive: "Get Active ",
  editTypeWeight: "Edit Type Weight",
  editSubtypeWeight: "Edit Subtype Weight",
  activate: "Activate",
  reset: "Reset",
  deleteDraft: "Delete Draft",
  getDraft: "Get Draft",
  addType: "ADD TYPE",
  riskValidation: "RISK VALIDATION",
  emiConfiguration: "FEE PAYMENT CONFIGURATION",
  combinedRating: "COMBINED RATING ",
  end: "End",
  weight: "Weight",
  set: "Set",
  deleteType: "Delete Type",
  deleteSubType: "Delete Sub Type",
  add: "Add",
  on: "On",
  lastModified: "Last modified",
  enterValueOf: "Enter value of",
  editSubtype: "Edit Sub Type",
  active: "Active",
  drafted: "Drafted",
  inactive: "Inactive",
  stayInSpain: "Stay in Spain",
  employmentSituation: "Employment situation",
  jobTime: "Job time",
  paymentTotalIncome: "Payment / Total income",
  paymentIncomeMinusExpenses: "Payment / (total income - Exepenses)",
  paymentOtherLoan: "(Payment + Other loan) / Total income)",
  addressValidation: "Address validation",
  error: "Error",
  validationByReference: "Validation by reference",
  Back: "Back",
  Detail: "Detail",
  Edit: "Edit",
  User: "User",
  Version: "Version",
  State: "State",
  LastModified: "LastModified",
  activateConfirmationMessage:
    "Are you sure you want to activate this credit score configuration ?",
  getActiveConfirmationMessage:
    "Are you sure you want to get activated credit score configuration ?",
  resetConfirmationMessage:
    "Are you sure you want to reset credit score configuration changes ?",
  deleteDraftConfirmationMessage:
    "Are you sure you want to delete credit score configuration draft ?",
  getDraftConfirmationMessage:
    "If you have made any changes, the changes will be lost. Do you want to continue?",
  saveAsDraftConfirmationMessage:
    "Are you sure you want to save this credit score configuration as a draft ?",
  deleteTypeConfirmationMessage:
    "Are you sure you want to delete this type and its contents?",
  deleteSubTypeConfirmationMessage:
    "Are you sure you want to delete this subtype?",
  backtotheversionList: "Are you sure you want to go back?",
  emailHasNotBeenSent: "E-mail has not been sent.",
  errorEmptyFields: "Mandatory fields are empty.",
  errorEmptyUserName: "Username is empty.",
  errorInvalidFirstName: "Invalid first name.",
  errorInvalidLastName: "Invalid last name.",
  errorInvalidBirthDate: "Invalid birth date.",
  errorInvalidAge: "Applicant's age must be between 18 to 65 years",
  errorSelectCountry: "Please select country.",
  errorInvalidEmail: "Invalid email.",
  errorInvalidMobileNumber: "Invalid mobile number.",
  errorInvalidPhoneNumber: "Invalid phone number.",
  errorInvalidId: "Invalid ID",
  errorInvalidPhoneNumberReference1: "Invalid phone number for reference 1.",
  errorInvalidPhoneNumberReference2: "Invalid phone number for reference 2.",
  errorInvalidNameReference1: "Invalid name of reference 1.",
  errorInvalidNameReference2: "Invalid name of reference 2.",
  errorInvalidDurationInCityAndCOuntry:
    "Duration of stay in spain can not be lesser than the duration of stay in city.",
  errorSelectMonthsAndYears: "Please select Months and Years.",
  errorSelectToAndFromDate: "Please select To and From Dates.",
  errorInvalidFromDate: "Invalid from date",
  errorSelectRangeToAndFromDate: "Please select Valid To and From Dates.",
  errorSelectUserBirthDateInvalid: "Minimum age for job is 15 years.",
  errorZeroIncome: "Income amount cannot be zero",
  errorInvalidUsernameOrPassword: "Invalid username or password.",
  errorNewPasswordAndConfirmPasswordAreNotSame:
    "New password and confirm password are not same.",
  errorInvalidOldPassword: "Invalid old password.",
  errorCreateLoanApplication: "Failed to create loan application.",
  errorUpdateLoanApplication: "Error al actualizar la solicitud de préstamo.",
  errorFileSize: "The size of selected file is greater than 50MB.",
  errorFileExtension: "Please select the file of type pdf, jpg or jpeg.",
  errorNoDocuments: "Please upload all the documents.",
  errorUploadDocuments: "Failed to upload document.",
  errorPhotoIsNotYetUploaded: "Photo is not yet uploaded",
  errorRemoveDocument: "Unable to remove document.",
  errorViewDocument: "Unable to load document.",
  errorUsernameAlreadyExist: "Username already exist.",
  errorRoleNotFound: "Role not found.",
  errorInvalidPhone: "Invalid phone number.",
  errorInvalidSizeAvatar: "Invalid size of photo.",
  errorEmailIdNotExist: "Email-id not exist",
  errorInGeneratingOTP: "Error in generating code.",
  errorPhotoRefresh: "Content not found.",
  errorToFetchTheInfoOfId: "Unable to fetch client info",
  errorGetLoanApplicationById: "Failed to get loan application details.",
  errorSaveLoanApplication: "Unable to save loan application.",
  errorApproveLoanApplication: "Unable to approve loan application.",
  errorUpdateLoanApplicationStatus: "Unable to update loan application status.",
  errorLoanDisbursement: "Unable to disburse loan.",
  errorTime: "Invalid time.",
  errorSelectManadatoryFields: "Please select all mandatory fields.",
  errorSignatureRefresh: "Content not found.",
  errorAddNote: "Failed to add note.",
  errorUpdateNote: "Failed to update note.",
  errorDeleteNote: "Failed to delete note.",
  errorGetAllNotes: "Failed to get all notes.",
  errorAnalysisDataNotFound: "Analysis data not found.",
  errorPendingLoanApplicationDetailsVerificationByLoanApplicant:
    "Pending loan application details verification by loan applicant.",
  errorPendingKontomatikConsentFromLoanApplicant:
    "Pending kontomatik consent from loan applicant.",
  errorKontomatikDataNotReceived: "Kontomatik data not received.",
  errorDisbursementCheckAllFields: "Please check all mandatory fields.",
  errorIncompleteRemittancesInformation: "Incomplete remittances information.",
  errorInvalidValue: "Input value should be between 0 and 100",
  errorInvalidTextValue:
    "Input value should be non empty and it's length should be less than 100",
  errorConfiguration: "There was an error",
  errorDraftedNotFound: "No drafted algorithm found",
  errorActiveNotFound: "No active algorithm found",
  errorInvalidAlgo: "Invalid algorithm string",
  errorVersionExists: "This version already exists",
  errorDraftedExists:
    "Cannot create new algorithm as a drafted algorithm already exists",
  errorCannotUpdate: "Not allowed to update because you are not the owner",
  errorAlgoNotFound: "Algorithm not found",
  errorAlgoNotDrafted: "Algorithm status is not drafted",
  InvalidConfigurationData: "Invalid algorithm data",
  errorEmptyValue: "Input value should be non empty.",
  errorStartValueShouldBeLessThanEndValue: "Start should be less than end.",
  errorInvalidInput: "Invalid input.",
  errorAllMappingsAreConfigured: "All mappings are configured.",
  errorPleaseSelectVariable: "Please select the variable",
  errorPleaseSelectTheValue: "Please select the Value.",
  errorDuplicateSelectionNotAllowed: "Duplicate selection is not allowed.",
  errorMappingdosenotMatches: "Mapping Doesn't Matches",
  errorDataNotavailable: "Data Not Available",
  versionDataNotAvailable: "Version Data Not Available",
  errorSomethingWentWrong: "Something Went wrong",
  errorToCreateLoanApplication:
    "Unable to create loan application as customer already has 3 loan applications",
  errorHistoryNotFound: "Transaction history not found",
  errorUnableToFetchHistory: "Unable to fetch transaction history",
  algorithmFetchSuccessfully: "Algorithm Fetched Successfully",
  successReset: "Configuration data reset successfully",
  successGetDrafted: "Fetched drafted configuration",
  successGetActive: "Fetched active configuration",
  successSaveAsDraft: "Configuration saved as draft",
  successDeleteDraft: "Deleted drafted configuration",
  successActivate: "Configuration activated",
  rate: "rate",
  duration: "duration",
  emi: "emi",
  feePayment: "Fee Payment",
  min: "min",
  max: "max",
  deleteAmount: "DELETE AMOUNT",
  addAmount: "ADD AMOUNT",
  addLoanIndex: "Add Loan Index",
  emiConfigurationFetchSuccessfully:
    "Fee Payment Configuration Fetched Successfully",
  errorDraftedEMIExists:
    "Cannot create new configuration, as there is already one drafted.",
  errorInvalidEMIConfiguration: "Invalid Fee Payment configuration string",
  InvalidEMIConfigurationData: "Invalid Fee Payment configuration data",
  errorDraftedEMIConfigNotFound: "No drafted Fee Payment configuration found",
  errorEMINotFound: "Fee Payment Configuration not found",
  errorEMINotDrafted: "Fee Payment Configuration status is not drafted",
  invalidEMIConfiguration:
    "Loan information does not match with the Fee Payment configuration.",
  "Annual count of transactions (Avg 2Y)":
    "Annual count of transactions (Avg 2Y)",
  "Annual amount sent/transfered ($) (Avg 2Y)":
    "Annual amount sent/transfered ($) (Avg 2Y)",
  "Years as an Europhil client": "Years as an Europhil client",
  beneficiaryRelationship: "Beneficiary Relationship",
  "Last 5 years behavior curve": "Last 5 years behavior curve",
  Remittances: "Remittances",
  errorInvalidBehaviorCurveValue: "Invalid Behavior Curve Value",
  warningDuplicateAmount: "Duplicate Amount",
  monthly: "monthly",
  historyFetchedSuccessfully: "History Fetched Successfully",
  graphFetchedSuccessfully: "Graph Fetched Successfully",
  activateEMIConfirmationMessage:
    "Are you sure you want to activate this Fee Payment configuration ?",
  getActiveEMIConfirmationMessage:
    "Are you sure you want to get active Fee Payment configuration ?",
  resetEMIConfirmationMessage:
    "Are you sure you want to reset Fee Payment configuration changes ?",
  deleteDraftEMIConfirmationMessage:
    "Are you sure you want to delete Fee Payment configuration draft ?",
  getDraftEMIConfirmationMessage:
    "If you have made any changes, the changes will be lost. Do you want to continue?",
  saveAsDraftEMIConfirmationMessage:
    "Are you sure you want to save this Fee Payment configuration as a draft ?",
  "select User": "select User",
  warningInfinityEmiValue: "Please enter a valid duration",
  notesUnavailable: "Notes not available",
  perPage: "Per Page",
  getLoanInfo: "GetLoanInfo",
  CSV: "CSV",
  postLoanPayment: "PostLoanPayment",
  scheduleNow: "Schedule Now",
  home: "Home",
  interest: "Interest",
  penalties: "Penalties",
  paid: "Paid",
  denied: "Denied",
  amount: "Amount",
  dueDate: "Due Date",
  customerId: "Customer Id",
  loanId: "Loan Id",
  createDate: "Create Date",
  disbursementDate: "Disbursement Date",
  loanInfo: "Loan Info",
  schedulerRunnig: "Scheduler Is now started",
  principle: "Principle",
  errorInputValue: "Imput value must not be empty",
  close: "Close",
  paymentNotAllowed: "Payment Is Not Allowed",
  isAdavancePayment: "Is it a Payment in Advance?",
  repayment: "Repayment",
  repaymentNo: "RepaymentNo",
  otherCharges: "Other Charges",
  lateFees: "Late Fees",
  capital: "Capital",
  details: "Transaction Details",
  scheduleDate: "planner date",
  advancePayment: "Advance Payment",
  advanceEmi: "Advance EMI",
  errorLoanApplicationNotFound: "Loan Application Not Found",
  NA: "N/A",
  customerUniqueId: "Holdo Id",
  documentType: "Document Type",
  documentNumber: "Document Number",
  documentExpirationDate: "Document Expiration Date",
  documentImages: "Document Images",
  profession: "Profession",
  nationality: "Country of Birth",
  bankAccountNumber: "Bank Account Number",
  thankYou: "Thank You For Visiting Quisqueya!",
  errorExpiredDocument: "Document is expired, we need new Id to proceed",
  errorInvalidAmount: "Amount should be greater than 300",
  errorContinuousRange: "Invalid range of amount.",
  errorAmountOverlap: "The amount range must not overlap.",
  minAmount: "Minimum amount",
  maxAmount: "Maximum amount",
  errorInvalidBankAccountNumber: "Invalid bank account number",
  ReportTo: "Report to",
  cashier_moderator: "Cashier Moderator",
  Reports: "Reports",
  loanAgreementDetails: "Loan Agreement Details",
  digitally: "Digitally",
  offline: "Offline",
  viewContract: "View Contract",
  disburse: "Disburse",
  visitingHours: "Visiting Hours",
  enterData: "Enter Data",
  Repayment: "Repayment",
  ONLINE: "Online",
  DIRECT_DEBIT: "Direct Debit",
  DEBIT_CARD: "Debit Card",
  CASH: "Cash",
  termsAndConditions: "Terms and Conditions",
  liveDataSuccessRequest:
    "your request for live data has been successfully raised. you will receive an email of live data.", //
  liveData: "live data", //
  pleaseSelectYear: "Please select year",//
  branchName : "Branch name",//
  branchCode: "branchCode",//
  provincia : "Provincia",//
  branchInformation: "Branch information",
  BRANCH_INFO: "Branch information",
};
